var lib_core = require("lib-core");
var QuadPadReplicatorData = require('./quadPadReplicatorData.js');
var lib_geometry = require('lib-geometry');
var RectangleData = require('../svg/rectangleData.js');

var GenericSmdQuadPadGeneratorData = function (position, angle, totalNumberOfVerticalPads, totalNumberOfHorizontalPads, horizontalLeadToLeadPitch, verticalLeadToLeadPitch, pinPitch) {
    QuadPadReplicatorData.apply(this, arguments);
};

lib_core.inherit(GenericSmdQuadPadGeneratorData, QuadPadReplicatorData);
lib_core.JsonParser.registerClass(GenericSmdQuadPadGeneratorData, "GenericSmdQuadPadGeneratorData");

module.exports = GenericSmdQuadPadGeneratorData;
